import classNames from 'clsx';
import { useContext, useState } from 'react';
import { logClientError, logSubscribeActivity } from 'src/common/actions/logging';
import { getSubscription, linkExistingSubscription } from 'src/common/actions/subscription';
import subscribe from 'src/common/constants/analytics/categoryActionLabel/subscribe';
import { RESTORE_PURCHASE_BUTTON } from 'src/common/constants/localizations/settings';
import tracking from 'src/common/constants/subscription/tracking';
import useActions from '../../../hooks/useActions';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import { currentSubscriptionStatus } from '../../../utils/subscription/subscriptionStatus';
import PillButton from '../../shared/button/PillButton';
import generalSettingsCss from '../general/general-settings.module.scss';
import RestoreResultDialog, { dialogs } from './RestoreResultDialog';
import css from './subscription.module.scss';

const RestorePurchase = () => {
  const [restoreResultDialog, setRestoreResultDialog] = useState(undefined);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const actions = useActions({
    getSubscription,
    logSubscribeActivity,
    linkExistingSubscription,
    logClientError,
  });

  const { getLocalizedText, location } = useContext(LocationAndLocalizationContext);

  const getSubscriptionStatus = async () => {
    try {
      actions.logSubscribeActivity(subscribe.actions.click, subscribe.labels.restore);

      const searchByAccountId = true;
      const result = await actions.getSubscription(searchByAccountId);
      return result?.value?.content?.status;
    } catch (error) {
      actions.logClientError({
        message: tracking.messages.getSubscriptionError,
        context: {
          error,
        },
      });
    }
  };

  const restoreSubscription = async () => {
    try {
      actions.logSubscribeActivity(subscribe.actions.triggered, subscribe.labels.restore); // log discrepancy found

      await actions.linkExistingSubscription(location);

      actions.logSubscribeActivity(subscribe.actions.success, subscribe.labels.link);
      setRestoreResultDialog(dialogs.success);
    } catch (e) {
      actions.logSubscribeActivity(subscribe.actions.fail, subscribe.labels.link);
      setRestoreResultDialog(dialogs.failure);
    }
  };

  const handleRestorePurchaseClick = async () => {
    setIsButtonDisabled(true);

    const subscriptionStatus = await getSubscriptionStatus();

    // Discrepancy: If an active sub found in Stripe for the current non-premium user, then restore the sub with calling linkSub endpoints.
    if (subscriptionStatus === currentSubscriptionStatus.active) {
      await restoreSubscription();
    } else {
      actions.logSubscribeActivity(subscribe.actions.noDiscrepancy, subscribe.labels.restore); // log no discrepancy found
      setRestoreResultDialog(dialogs.noPurchase);
    }
  };

  return (
    <div className={classNames('row', css.restorePurchaseRow)}>
      <div className="col-xs-12 col-sm-4">
        <PillButton
          dataTestId="restorePurchaseButton"
          id="restorePurchaseButton"
          className={generalSettingsCss.settingsButton}
          label={getLocalizedText(RESTORE_PURCHASE_BUTTON)}
          onClick={handleRestorePurchaseClick}
          isDisabled={isButtonDisabled}
        />
      </div>
      <RestoreResultDialog
        dialog={restoreResultDialog}
        shouldShow={!!restoreResultDialog}
        handleClose={() => setRestoreResultDialog()}
      />
    </div>
  );
};

export default RestorePurchase;
